// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"363":"95a8ce93","893":"ffacbec9"}[chunkId] + ".chunk.css";
};